import './abilities.scss';

import { SettingsContext } from 'context/context';
import { useContext } from 'react';

function Abilities({unit_abilities}) {
  const { state } = useContext(SettingsContext);

  const filterAbilities = (abilities) => {
    let filteredAbilities = abilities;
    if (!state.displayEquipment) {
      filteredAbilities = filteredAbilities.filter((ability) => !ability.addon)
    }

    return filteredAbilities.map((ability, index) => {
      return (<span key={index}>
        <p>
          <b dangerouslySetInnerHTML={{__html: `${ability.name} `}}/>{ state.succinctAbilities ? null : ': ' }
          { state.succinctAbilities ? null :   <span dangerouslySetInnerHTML={{__html: ability.description}}/> }
        </p>
      </span>);
    });
  }

  return (
    <div className="abilities">
      <h4>Abilities</h4>
      { filterAbilities(unit_abilities) }
    </div>
  );
}

export default Abilities;
